import { activeOnboardingConfig } from './active-config'
import { useOnboardingStore } from './onboarding-store'

/**
 * App → checklist progress bridge (spec D4 completion detection). Call sites
 * emit semantic events ('watchlist-add', 'companion-ask', ...) with no
 * knowledge of checklists; this module maps them onto the user's ACTIVE
 * checklist items via the onboarding config. Everything is a cheap no-op when
 * no checklist is active, so emit points cost nothing for existing users.
 * A dismissed checklist still progresses: hiding the card is not opting out
 * of the funnel, and dismissal used to stop all tracking.
 */

/** An app event occurred: progress any active checklist items keyed to it. */
export function emitChecklistSignal(signal: string): void {
  const state = useOnboardingStore.getState()
  const checklist = state.checklist
  if (!checklist) return
  const def = activeOnboardingConfig().checklists[checklist.id]
  if (!def) return
  for (const item of def.items) {
    if (item.signal === signal) state.incrementChecklistCount(item.id, item.target)
  }
}

/** A guided walkthrough finished: complete any items backed by its slug. */
export function markWalkthroughDone(slug: string): void {
  const state = useOnboardingStore.getState()
  const checklist = state.checklist
  if (!checklist) return
  const def = activeOnboardingConfig().checklists[checklist.id]
  if (!def) return
  for (const item of def.items) {
    if (item.walkthrough === slug) state.markChecklistDone(item.id)
  }
}
